var map = {
	"./bag": 2,
	"./bag.jpeg": 43,
	"./bag.png": 2,
	"./banner-1": 8,
	"./banner-1.png": 8,
	"./camera": 9,
	"./camera.jpeg": 9,
	"./car-key": 10,
	"./car-key.jpeg": 10,
	"./doodle-old.PNG": 44,
	"./doodle.PNG": 45,
	"./icons-items": 11,
	"./icons-items.svg": 11,
	"./ipad": 12,
	"./ipad.jpeg": 12,
	"./kalaahaus-32x32": 13,
	"./kalaahaus-32x32.png": 13,
	"./keys": 6,
	"./keys.png": 6,
	"./laptop": 14,
	"./laptop.jpeg": 14,
	"./leads": 15,
	"./leads.png": 15,
	"./lease": 16,
	"./lease.png": 16,
	"./link": 17,
	"./link.png": 17,
	"./luggage": 18,
	"./luggage.jpeg": 18,
	"./my_pet_clinic": 19,
	"./my_pet_clinic.png": 19,
	"./notification": 20,
	"./notification.jpeg": 20,
	"./pet": 21,
	"./pet-avatar": 22,
	"./pet-avatar.png": 22,
	"./pet.jpeg": 21,
	"./quotes": 23,
	"./quotes.svg": 23,
	"./register": 24,
	"./register.png": 24,
	"./registered": 25,
	"./registered.png": 25,
	"./return-item": 26,
	"./return-item.png": 26,
	"./return-pets": 27,
	"./return-pets.png": 27,
	"./sankro": 28,
	"./sankro-full-1": 29,
	"./sankro-full-1.png": 29,
	"./sankro-keycgain": 30,
	"./sankro-keycgain.jpeg": 30,
	"./sankro.PNG": 46,
	"./sankro.jpeg": 28,
	"./scan": 31,
	"./scan-tag": 32,
	"./scan-tag.png": 32,
	"./scan.png": 31,
	"./tag-banner": 33,
	"./tag-banner.jpeg": 33,
	"./the-tags": 34,
	"./the-tags.png": 34,
	"./tumbler": 35,
	"./tumbler.jpeg": 35,
	"./wallet": 36,
	"./wallet.jpeg": 36,
	"./whatsapp": 37,
	"./whatsapp.png": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;